import axios from "axios";
import store from "store";
import {contactRead} from "@/store/contactsStore";
import {
    EventBus
} from "../Bus";
import badgeService from "@/Services/badgeService";

const TOKEN_KEY = "mm-chat.token";

const ERROR_CODE = {
    AUTH: 406
};

export default class {

    constructor() {
        this.token = store.get(TOKEN_KEY) || "";
        this.api = global.API_URI || "http://mm-chat.demo2.mixmedia.com/api";

        this.http = axios.create({
            baseURL: this.api,
        })

        // Add a request interceptor
        this.http.interceptors.request.use((config) => {
            config = Object.assign(config, {
                headers: {
                    Authorization: this.token
                }
            });
            return config;
        });

        this.http.interceptors.response.use(function (resp) {
            let json = resp.data;
            if (json && json.status == 1) {
                return json.data;
            }
            if (json && json.error) {
                if (json.error.code == ERROR_CODE.AUTH) {
                    EventBus.dispatchAuthError();
                }
                return Promise.reject(json.error);
            }

            return Promise.reject();
        });
    }

    getMessages( from, next_id = 0, prev_id = 0, msg_id = 0 ) {
        // console.log('搜索点击id', from, next_id, prev_id, msg_id)
        return this.http.get("/msg", {
            params: {
                from,
                next_id,
                prev_id,
                msg_id
            }
        });
    }

    Send(to, type, content) {
        return this.http.post("/msg/send", {
            to: to,
            content: content,
            type: type
        });
    }

    read(uid) {
        return this.http.post('/contacts/read/' + uid, {
            uid: uid
        }).then((resp) => {
            contactRead(uid)
                .then(() => {
                    badgeService.remove(uid);
                });
            return Promise.resolve(resp);
        })
    }

    msg_search_lsit( from, message_id = 0){
        return this.http.get('/msg/searchlist', {
            params:{
                from,
                message_id
            }
        })
    }


    templateList() {
        return this.http.get('/msg/available_template_list')
    }

    sendTemplate(to, template_id) {
        return this.http.post('/msg/send/template', {
            to,
            template_id,
        })
    }
}
